// extracted by mini-css-extract-plugin
var _1 = "FileLoader_active__83f8f";
var _2 = "FileLoader_bold__3658c";
var _3 = "FileLoader_buttons__14cbd";
var _4 = "FileLoader_description__d99e2";
var _5 = "FileLoader_editButton__c5a5d";
var _6 = "FileLoader_empty__fa5e8";
var _7 = "FileLoader_fields__09ac6";
var _8 = "FileLoader_footer__4d7cc";
var _9 = "FileLoader_full__1e859";
var _a = "FileLoader_icon__aebba";
var _b = "FileLoader_info__a964c";
var _c = "FileLoader_infoIcon__cefbe";
var _d = "FileLoader_label__c4a79";
var _e = "FileLoader_link__cd9de";
var _f = "FileLoader_preview__c647e";
var _10 = "FileLoader_root__1e1a8";
var _11 = "FileLoader_title__f5ad1";
var _12 = "FileLoader_wrapper__a44e4";
export { _1 as "active", _2 as "bold", _3 as "buttons", _4 as "description", _5 as "editButton", _6 as "empty", _7 as "fields", _8 as "footer", _9 as "full", _a as "icon", _b as "info", _c as "infoIcon", _d as "label", _e as "link", _f as "preview", _10 as "root", _11 as "title", _12 as "wrapper" }
